import BuoyCard from "./BuoyCard";
import {  useSelector } from "react-redux";

function Buoys() {
    const breakDetail = useSelector(state => state.breaks.breakDetail);

    return(
        <div>
            <h2>Buoys For This Break</h2>
            <div className='flex flex-row flex-wrap justify-center space-between m-3'>
                {breakDetail.buoys.map(station => {
                    return <BuoyCard 
                            key={station.id}
                            name={station.name}
                            id={station.id}
                            lat={station.lat}
                            lon={station.lon}
                            owner={station.owner}
                            elev={station.elev}
                        />
                })}
            </div>
        </div>
    )

}

export default Buoys;